module.exports = "/images/a1710f1234a07d25fcb64aef793642d7.svg";